import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";
import { Reveal } from "./Reveal";

const BARS = [["Protein", 22, "g", 46, "#3EE6FF"], ["Carbs", 23, "g", 8, "#FFB21A"], ["Sugar", 8, "g", 8, "#FF6F91"], ["Fibre", 7, "g", 28, "#7BD88F"], ["Fat", 0, "g", 0, "#1B1530"]];

export const Nutrition = () => (
  <section data-testid="nutrition-facts-section" className="pb-24 lg:pb-32">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-12 items-start">
      <Reveal className="lg:col-span-5">
        <div className="relative max-w-sm mx-auto rotate-[-2deg] hover:rotate-0 transition-transform duration-700">
          <div className="absolute -inset-4 bg-[#BDE3FA] rounded-[28px] rotate-[4deg]" />
          <img src="/img/nutrition.jpg" alt="Swole Bears nutrition facts per 70g bag: 150 calories, 0g fat, 55mg sodium, 23g carbs, 7g fibre, 8g sugar, 22g protein"
            data-testid="nutrition-label-image" className="relative rounded-2xl w-full bg-white p-3" loading="lazy" />
        </div>
      </Reveal>
      <div className="lg:col-span-6 lg:col-start-7">
        <p className="text-base sm:text-lg text-[#4A4560]">Per 70g bag · 150 calories · same great macros in every flavour.</p>
        <div className="mt-8 space-y-5" data-testid="macro-bars">
          <div className="grid grid-cols-[70px_1fr_52px_44px] gap-3 sm:gap-4 text-[11px] font-bold uppercase tracking-wider text-[#4A4560]">
            <span />
            <span>% Daily Value per bag</span>
            <span className="text-right">Amount</span>
            <span className="text-right">%DV</span>
          </div>
          {BARS.map(([k, v, u, dv, c], i) => (
            <div key={k} data-testid={`macro-bar-${k.toLowerCase()}`} className="grid grid-cols-[70px_1fr_52px_44px] items-center gap-3 sm:gap-4">
              <span className="font-bold text-sm">{k}</span>
              <div className="h-3.5 rounded-full bg-[#1B1530]/10 overflow-hidden">
                <motion.div className="h-full rounded-full origin-left" style={{ background: c, width: `${dv}%` }}
                  initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.2, delay: i * 0.08, ease: EASE }} />
              </div>
              <span className="font-display text-2xl text-right">{v}{u}</span>
              <span className="text-xs font-semibold text-[#4A4560] text-right">{dv}%</span>
            </div>
          ))}
          <p className="text-xs text-[#4A4560]">Bars show % Daily Value from the label. Sodium 55mg (2%). Cholesterol 0mg.</p>
        </div>
      </div>
    </div>
  </section>
);
